import "antd/es/space/style";
import _Space from "antd/es/space";
import "antd/es/button/style";
import _Button from "antd/es/button";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useIntl } from '@ant-design/pro-provider';
/**
 * FormFooter 的组件，可以自动进行一些配置
 * @param props
 */

var Submitter = function Submitter(props) {
  var intl = useIntl();

  if (props.render === false) {
    return null;
  }

  var form = props.form,
      onSubmit = props.onSubmit,
      render = props.render,
      onReset = props.onReset,
      _props$searchConfig = props.searchConfig,
      searchConfig = _props$searchConfig === void 0 ? {} : _props$searchConfig,
      submitButtonProps = props.submitButtonProps,
      resetButtonProps = props.resetButtonProps;
  var _searchConfig$submitT = searchConfig.submitText,
      submitText = _searchConfig$submitT === void 0 ? intl.getMessage('tableForm.submit', '提交') : _searchConfig$submitT,
      _searchConfig$resetTe = searchConfig.resetText,
      resetText = _searchConfig$resetTe === void 0 ? intl.getMessage('tableForm.reset', '重置') : _searchConfig$resetTe;
  /**
   * 默认的操作的逻辑
   */

  var dom = [/*#__PURE__*/React.createElement(_Button, _extends({}, resetButtonProps, {
    key: "rest",
    onClick: function onClick(e) {
      var _resetButtonProps$onC;

      form.resetFields();
      onReset === null || onReset === void 0 ? void 0 : onReset();
      resetButtonProps === null || resetButtonProps === void 0 ? void 0 : (_resetButtonProps$onC = resetButtonProps.onClick) === null || _resetButtonProps$onC === void 0 ? void 0 : _resetButtonProps$onC.call(resetButtonProps, e);
    }
  }), resetText), /*#__PURE__*/React.createElement(_Button, _extends({
    type: "primary"
  }, submitButtonProps, {
    key: "submit",
    onClick: function onClick(e) {
      var _submitButtonProps$on;

      form.submit();
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
      submitButtonProps === null || submitButtonProps === void 0 ? void 0 : (_submitButtonProps$on = submitButtonProps.onClick) === null || _submitButtonProps$on === void 0 ? void 0 : _submitButtonProps$on.call(submitButtonProps, e);
    }
  }), submitText)];
  var renderDom = render ? render(props, dom) : dom;

  if (!renderDom) {
    return null;
  }

  if (Array.isArray(renderDom)) {
    if ((renderDom === null || renderDom === void 0 ? void 0 : renderDom.length) < 1) {
      return null;
    }

    return /*#__PURE__*/React.createElement(_Space, null, renderDom);
  }

  return renderDom;
};

export default Submitter;